import React from "react";

export const TimeFrame = React.createContext(null);
